/**
 * INSIGHT_MULTI_COLUMN_CHART_CONFIG: a JSON object representing a schema used to drive the chart
 * in the desktop view of the scenario analysis section.
 */
export const INSIGHT_MULTI_COLUMN_CHART_CONFIG_PDF = {
	chart: {
		height: 100,
		width: 80,
		style: {
			fontFamily: '"FortBook", Arial, sans-serif',
			color: '#616161',
			fontSize: '8px'
		},
		type: 'column'
	},
	plotOptions: {
		column: {
			pointWidth: '10',
			groupPadding: 0.85,
			pointPadding: 0
		}
	},
	xAxis: {
		categories: [],
		title: { text: null },
		visible: false
	},
	yAxis: {
		categories: [],
		tickInterval: 2,
		tickAmount: 5,
		opposite: true,
		title: { text: null },
		labels: {
			style: {
				textOverflow: 'none',
				fontSize: '8px'
			},
			x: -5,
			y: -1,
			formatter: function (): string {
				// apply % format to the first and last values of the yAxis while hiding the remainder of the values.
				if (this.isFirst || this.isLast) {
					if (parseInt(this.value, 10) !== 0) {
						return this.value + '%';
					} else {
						return this.value;
					}
				} else {
					this.value = '';
					return this.value;
				}
			}
		}
	},
	colors: [],
	extensibleData: null,
	series: [],
	tooltip: {
		enabled: false
	}
};
